import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auth-required"
}
const _hoisted_2 = { class: "auth-message" }
const _hoisted_3 = {
  key: 1,
  class: "main-content"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "loading"
}
const _hoisted_6 = {
  key: 1,
  class: "error-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["AppHeader"], {
      user: $setup.user,
      "is-authenticated": $setup.isAuthenticated,
      onLogin: _cache[0] || (_cache[0] = $event => ($setup.showAuthModal = true)),
      onLogout: $setup.handleLogout,
      onUserUpdated: $setup.handleUserUpdated
    }, null, 8 /* PROPS */, ["user", "is-authenticated"]),
    (!$setup.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Welcome to Film Manager", -1 /* CACHED */)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Please log in to access your movies and manage your collection.", -1 /* CACHED */)),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = $event => ($setup.showAuthModal = true)),
              class: "btn-primary"
            }, "Login or Register")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("main", _hoisted_4, [
            ($setup.store.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
              : _createCommentVNode("v-if", true),
            ($setup.store.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.store.error), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["JobHandler"]),
            ($setup.currentView === 'list')
              ? (_openBlock(), _createBlock($setup["MovieList"], {
                  key: 2,
                  movies: $setup.store.movies,
                  onSelectMovie: $setup.handleSelectMovie
                }, null, 8 /* PROPS */, ["movies"]))
              : ($setup.currentView === 'new')
                ? (_openBlock(), _createBlock($setup["NewMovie"], {
                    key: 3,
                    schema: $props.schema
                  }, null, 8 /* PROPS */, ["schema"]))
                : ($setup.currentView === 'edit' && $setup.store.currentMovie)
                  ? (_openBlock(), _createBlock($setup["MovieForm"], {
                      key: 4,
                      schema: $props.schema,
                      movie: $setup.store.currentMovie,
                      "is-creating-new": false
                    }, null, 8 /* PROPS */, ["schema", "movie"]))
                  : _createCommentVNode("v-if", true)
          ])
        ])),
    _createVNode($setup["AuthModal"], {
      show: $setup.showAuthModal,
      onClose: _cache[2] || (_cache[2] = $event => ($setup.showAuthModal = false)),
      onAuthSuccess: $setup.handleAuthSuccess
    }, null, 8 /* PROPS */, ["show"]),
    _createVNode($setup["Modal"])
  ], 64 /* STABLE_FRAGMENT */))
}